"use client"

import { ComponentProps } from "react"
import { View } from "react-native"
import { styled } from "nativewind"

export const Box = styled(View, "")
export type BoxProps = ComponentProps<typeof Box>
